import React from 'react'
import { Routes, Route } from 'react-router-dom'
import ZarrExplorer from './pages/ZarrExplorer'

function App() {
  return (
    <div className="app-shell">
      <Routes>
        <Route path="*" element={<ZarrExplorer />} />
      </Routes>
    </div>
  )
}

export default App
